<template>
  <template v-if="editionMode">
    <SelectComponent
      v-model="selectedValues"
      :name="name"
      :label="label ?? $t('attributes.funeral_home')"
      :values="filteredFuneralHomes"
      display-key="name"
      :multiple="multiple"
      :favorite="favoriteAsArray"
      :required="required"
      :edition-mode="editionMode"
      :errors="errors"
      :class="$attrs.class"
    />
  </template>
  <BaseShowLabel
    v-else
    :label="label ?? $t('attributes.funeral_home')"
    :model-value="selectedLabel"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'

export default {
  name: 'SelectFuneralHome',
  components: { BaseShowLabel, SelectComponent },
  props: {
    modelValue: {
      type: [Array, Number],
      required: true
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    errorKey: {
      type: String,
      required: false,
      default: null
    },
    filterCompanyId: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: false,
      default: 'funeral_home'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters('metadata', { funeralHomes: 'getFuneralHomesMetadata' }),
    filteredFuneralHomes() {
      if (!this.filterCompanyId) {
        return this.funeralHomes
      }
      return this.funeralHomes.filter(
        (item) => item.company_id === this.filterCompanyId
      )
    },
    favoriteAsArray() {
      return this.funeralHomes
        .filter((funeralHome) => funeralHome.favorite === 1)
        .map((funeralHome) => funeralHome.id)
    },
    selectedLabel() {
      return this.funeralHomes.find(
        (funeral_home) => funeral_home.id === this.modelValue
      )?.name
    }
  }
}
</script>
